import React from 'react'
import { useRecordContext, NumberField, FieldProps } from 'react-admin'
import { useDocumentCounts } from './DocumentCountContext'

const DocumentCountField = (props: FieldProps) => {
  const record = useRecordContext()
  const { counts, loading, error } = useDocumentCounts()

  if (loading || error || !record?.id) {
    return <span>-</span>
  }

  const count = counts.get(String(record.id)) ?? 0

  // Create a modified record with the count to pass to NumberField
  const recordWithCount = { ...record, kmChatsCount: count }

  return <NumberField {...props} record={recordWithCount} source='kmChatsCount' />
}

export default DocumentCountField
